/* eslint-disable turbo/no-undeclared-env-vars */
import { handleError } from '@/utils/errors';

interface Environment {
  environment: string;
  softphoneClientUrl: string;
}

let init: ((value: Environment | PromiseLike<Environment>) => void) | undefined;
let environmentPromise = new Promise<Environment>((resolve) => {
  init = resolve;
});

export const EnvironmentService = {
  init: () => {
    const loadEnvironment: Promise<Environment> = fetch(
      `${window.location.origin}/environment.json`,
    )
      .then((response) => response.json())
      .catch((error) => {
        handleError(error, { displayToast: false });
        return {
          environment: '',
          softphoneClientUrl: '',
        };
      });
    environmentPromise = loadEnvironment;
    if (init) {
      init(loadEnvironment);
      init = undefined;
    }
  },

  getEnvironment: async () => {
    // @ts-ignore
    const fromEnv = process.env.POD_ENVIRONMENT;

    if (typeof fromEnv === 'string' && fromEnv && fromEnv !== 'undefined' && fromEnv !== 'null') {
      return fromEnv;
    }

    return (await environmentPromise).environment;
  },

  getSoftphoneClientUrl: async () => {
    // @ts-ignore
    const fromEnv = process.env.SOFTPHONE_CLIENT_URL;

    if (typeof fromEnv === 'string' && fromEnv && fromEnv !== 'undefined' && fromEnv !== 'null') {
      return fromEnv;
    }

    return (await environmentPromise).softphoneClientUrl;
  },
};
